import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import ServicesGrid from "@/components/ServicesGrid";
import Pricing from "@/components/Pricing";
import StrategySection from "@/components/StrategySection";
import Showreel from "@/components/Showreel";
import Manifesto from "@/components/Manifesto";
import Faq from "@/components/Faq";
import CtaBand from "@/components/CtaBand";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { scrollToSection } from "@/data/catalog";

export default function HomePage() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = location.state.scrollTo;
      const timers = [150, 900, 1800].map((ms) => setTimeout(() => scrollToSection(target), ms));
      window.history.replaceState({}, "");
      return () => timers.forEach(clearTimeout);
    }
  }, [location.state]);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <ServicesGrid />
        <Pricing />
        <StrategySection />
        <Showreel />
        <Manifesto />
        <Faq />
        <CtaBand />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
